// =====================================================================
// Catégories d'une course — ajouté le 01.10.2026.
// Définies par l'organisateur (fenêtre "Gérer les catégories") et
// enregistrées dans la config de la course (swissski-config, champ
// `categories`). Elles servent :
//   - à l'ORDRE d'affichage/impression des groupes (liste de départ,
//     classements PDF…) ;
//   - à l'attribution automatique d'une catégorie aux participants
//     (genre + années de naissance).
//
// Une catégorie : { name, gender: "" | "M" | "W", yearFrom, yearTo }
// (yearFrom/yearTo = années de naissance, bornes incluses, vides = sans limite)
// À placer dans src/utils/.
// =====================================================================

export function normalizeGender(g) {
    const s = String(g || "").trim().toUpperCase();
    if (!s) return "";
    if (["M", "H", "MEN", "HERREN", "HOMMES"].includes(s) || s.startsWith("M")) return "M";
    if (["W", "F", "L", "D", "WOMEN", "DAMEN", "DAMES", "LADIES"].includes(s) || /^[WFLD]/.test(s)) return "W";
    return s;
}

// Rang d'une catégorie dans l'ordre défini ; inconnue -> après toutes les
// catégories définies (puis ordre alphabétique entre inconnues).
export function categoryRank(name, categories) {
    const idx = (categories || []).findIndex((c) => String(c.name) === String(name));
    return idx === -1 ? Number.MAX_SAFE_INTEGER : idx;
}

export function compareCategories(a, b, categories) {
    const ra = categoryRank(a, categories);
    const rb = categoryRank(b, categories);
    if (ra !== rb) return ra - rb;
    return String(a).localeCompare(String(b));
}

export function sortCategoryNames(names, categories) {
    return [...names].sort((a, b) => compareCategories(a, b, categories));
}

// Regroupe une liste par catégorie, groupes dans l'ordre défini, chaque
// groupe gardant l'ordre d'origine de la liste (ordre de départ, rang…).
export function groupByCategoryOrdered(list, categories, emptyLabel = "(sans catégorie)") {
    const byCat = new Map();
    (list || []).forEach((a) => {
        const cat = a.category || emptyLabel;
        if (!byCat.has(cat)) byCat.set(cat, []);
        byCat.get(cat).push(a);
    });
    return sortCategoryNames([...byCat.keys()], categories).map((cat) => ({ category: cat, entries: byCat.get(cat) }));
}

// Première catégorie (dans l'ordre défini) dont les règles correspondent
// à l'athlète ; null si aucune. Une catégorie sans aucune règle ne
// correspond à personne (elle ne sert qu'à l'ordre).
export function matchCategory(athlete, categories) {
    const year = Number(athlete.birthyear);
    const gender = normalizeGender(athlete.gender);
    for (const c of categories || []) {
        const hasRule = c.gender || c.yearFrom || c.yearTo;
        if (!hasRule) continue;
        if (c.gender && c.gender !== gender) continue;
        if (c.yearFrom && !(year >= Number(c.yearFrom))) continue;
        if (c.yearTo && !(year <= Number(c.yearTo))) continue;
        return c;
    }
    return null;
}